var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player-container",class:{
		view_unpicked: _vm.view_options.unpicked,
		view_picked: _vm.view_options.picked,
		view_queue: _vm.view_options.queue,
	}},_vm._l((_vm.players),function(player,id){return _c('div',{key:id,staticClass:"player",class:{
			unpicked: !_vm.is_picked(id),
			picked: _vm.is_picked(id),
			queued: player.is_queued,
		},on:{"click":function($event){return _vm.view_player(player, id)}}},[_c('span',{staticClass:"player-name"},[_vm._v(_vm._s(player.name))]),_c('span',{staticClass:"player-position"},[_vm._v(_vm._s(player.position)+" - "+_vm._s(player.team))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }